module.exports = __webpack_public_path__ + "static/img/cabecera.470ce4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/contactenos-en/cabecera.jpg
// module id = LqK3
// module chunks = 0